export default __webpack_public_path__ + "static/blog-preview-2-f4973ebb662e67f3057dd3da98d64111.jpeg";